import { useEffect, useState } from "react";
import { BaseContainer } from "../../core/base_container"
import { toast } from "react-toastify";
import { axiosBaseURL } from "../../http";
import { Button, Card, Modal, Row, Spinner } from "react-bootstrap";
import { NoneFound } from "../../core/none_found";
import { Clipboard2Data } from "react-bootstrap-icons";
import { Request } from "./components/request_view";

export const MyRequest = () => {
    const [requests, setRequests] = useState(null)
    const [modalShow, setModalShow] = useState(false)
    const [selectedReqID, setSelectedReqID] = useState(null)

    useEffect(() => {
        axiosBaseURL.get("request_api/requests/exoneree_requests/")
            .then((response) => {
                console.log(response.data)
                setRequests(response.data)
            }).catch(function (error) {
                toast.error('Failed to fetch requests.')
            });
    }, []);

    const handleNotesClick = (item_id) => {
        setSelectedReqID(item_id)
        setModalShow(true)
    }

    return (
        <BaseContainer>
            {requests === null ? (
                <Row className="justify-content-center">
                    <Spinner animation="border" role="status" variant="primary">
                        <span className="visually-hidden">Loading…</span>
                    </Spinner>
                </Row>
            ) : Array.isArray(requests) && requests.length > 0 ? (

                <div className="mt-3" style={{ overflow: 'scroll' }}>
                    {
                        requests.map((item, index) => (
                            <Card className="mb-3 shadow-sm">
                                <Card.Body>
                                    <Card.Text>
                                        <h5><Clipboard2Data color='purple' /> {item.request_type}</h5>
                                        <p>Status: {item.get_status_display}</p>
                                    </Card.Text>
                                </Card.Body>
                                <div className="d-flex justify-content-end m-2">
                                    <Button onClick={() => handleNotesClick(item.id)} variant='outline-primary' className='rounded-pill'>View Notes</Button>
                                </div>
                            </Card>
                        ))
                    }
                </div>
            ) : (
                <Row className="justify-content-center">
                    <NoneFound item_name={'Requests'} />
                </Row>
            )}
            {selectedReqID &&
                <Modal
                    size="lg"
                    centered
                    scrollable
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Request
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Request request_id={selectedReqID}/>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setModalShow(false)}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            }
        </BaseContainer>
    )
}